import { tap, pipe } from 'wonka';
import { get } from 'lodash';
import store from 'store';
import { publishAlert } from 'actions';
import { TOAST_TYPES } from 'components/common_v2/toasts/';

export const alertExchange = ({ forward }) => operations$ => pipe(
  forward(operations$),
  tap(result => {
    const error = get(result, 'error.graphQLErrors[0]', {});
    const isHumanReadable = get(error, 'extensions.human_readable', false);
    const fingerprint = get(error, 'extensions.fingerprint');
    const errorMessage = get(error, 'message');

    if (isHumanReadable && errorMessage) {
      store.dispatch(
        publishAlert({
          type: TOAST_TYPES.ERROR,
          message: errorMessage,
          duration: 4000,
          meta: {
            fingerprint
          }
        })
      );
    }
  })
);

